import { useSelector } from "react-redux";
import { FloatPanel } from "../../../../../components/floatPanel";
import { DiscountEditor } from "./reference";
import "./reference.css";
export const Edition = () => {
  const panel = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel,
  );
  return (
    <FloatPanel
      className="discountReferencePanel"
      template={<DiscountEditor key={`${panel.queryId}-${panel.isEmpty}`} />}
    />
  );
};
